var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dropdown',{attrs:{"icon":"far fa-globe","theme":"trans","selected":_vm.$store.getters.lang ?? 'en',"items":_vm.items,"show-selected":false,"menu-position":'br',"aria-label":_vm.$t('labels.language')},on:{"change":_vm.selectLanguage}})
}
var staticRenderFns = []

export { render, staticRenderFns }